class frequentBought extends HTMLElement{
  constructor(){
    super();
    this.cardCheckbox = this.querySelectorAll('.rec-product-wrapper input[type=checkbox]');
    if(this.cardCheckbox) this.cardCheckbox.forEach(item => item.addEventListener('change', this.updateCardCheckbox.bind(this)));
    this.cardInputRadio = this.querySelectorAll('.rec-product-wrapper input[name*="swatch-option"]');
    if(this.cardInputRadio) this.cardInputRadio.forEach(item => item.addEventListener('change', this.updateVariants.bind(this)));
    this.selectedProductIds = [];
    this.selectedVariantIds = [];
    this.selectedVariantPrices = [];
    this.submitBtn = this.querySelector('button[type="submit"]');
    if(this.submitBtn) this.submitBtn.addEventListener('click', this.submitFrequentBought.bind(this));
    this.init();
  }

  submitFrequentBought = async (event) => {
    event.preventDefault();
    const submitBtn = event.currentTarget;
    submitBtn.setAttribute('aria-busy', 'true');
    submitBtn.setAttribute('disabled', 'disabled');

    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    sectionsToBundle.push(document.querySelector('.shopify-section.shopify-section--announcement-bar')?.querySelector('height-observer')?.getAttribute('data-section-id'));

    if(this.selectedVariantIds.length == 0) return;
    const items = this.selectedVariantIds.map(variantId => ({
      id: variantId,
      quantity: 1
    }));

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items, sections: sectionsToBundle })
      });
  
      const responseJson = await response.json();

      if (response.ok) {
        if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
          return window.location.href = `${Shopify.routes.root}cart`;
        }
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json(); 
        window.globalVariables.cart = cartContent;
        cartContent["sections"] = responseJson["sections"];
        this.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
            cart: cartContent
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent
          }
        }));
      } else {
        this.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: responseJson["description"]
          }
        }));
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
    submitBtn.removeAttribute('aria-busy');
    submitBtn.removeAttribute('disabled');
    window.checkProductTypePassKit();
  }

  updateCardCheckbox = (event) => {
    var prId = event.currentTarget.value;
    if (event.currentTarget.checked) {
      this.selectedProductIds.push(prId);
    } else {
      this.selectedProductIds = this.selectedProductIds.filter(item => item !== prId);
    }
    this.selectedProductIds.length > 0 ? this.submitBtn?.removeAttribute('disabled') : this.submitBtn?.setAttribute('disabled', true);
    this.updateVariants();
  }
  
  setupVariantPrice = event => {
    if (event) {
      var pr_price = event.target.getAttribute('data-variant-value') || 0;
      var pr_compare_price = event.target.getAttribute('data-variant-compare-value') || 0;
      var price_list = event.target.closest('.rec-product-wrapper')?.querySelector('.price-list');
      if (price_list) {
        var comparePrice = price_list.querySelector('compare-at-price');
        var price = price_list.querySelector('sale-price');
        if (pr_compare_price > pr_price && pr_compare_price != null && pr_compare_price != 0) {
          comparePrice.classList.remove('d-none');
          comparePrice.innerHTML = window.formatMoney(pr_compare_price, window.globalVariables.money_format)
        } else {
          comparePrice.classList.add('d-none');
        }
        price.innerHTML = window.formatMoney(pr_price, window.globalVariables.money_format)
      }
    }
  }

  setupVariantImage = (event) => {
    if (event) {
      var pr_image = event.target.getAttribute('data-variant-image') || null;
      var image_list = event.target.closest('.rec-product-wrapper')?.querySelector('img.also-bought-product-card');
      if (pr_image) {
        image_list.removeAttribute('srcset');
        image_list.setAttribute('src', pr_image);
      }
    }
  }

  updateVariants = (event) => {
    this.setupVariantPrice(event);
    this.setupVariantImage(event);
    this.selectedVariantIds = [];
    this.selectedVariantPrices = [];
    this.selectedProductIds.forEach(id => {
      var varId = this.querySelector(`.rec-product-wrapper[data-product-id="${id}"] input[name*="swatch-option"]:checked`) ? (this.querySelector(`.rec-product-wrapper[data-product-id="${id}"] input[name*="swatch-option"]:checked`).value) : (this.querySelector(`.rec-product-wrapper[data-product-id="${id}"] input[name*="swatch-option"]`)?.value);
      if (varId) this.selectedVariantIds.push(varId);
      var price = this.querySelector(`.rec-product-wrapper[data-product-id="${id}"] input[name*="swatch-option"][value="${varId}"]`).getAttribute('data-variant-value') || 0;
      if (price) this.selectedVariantPrices.push(price);
    })

    var totalPrice = 0;
    this.selectedVariantPrices.forEach(pr => {
      totalPrice += parseFloat(pr);
    })
    var addOnPrice = window.formatMoney(totalPrice, window.globalVariables.money_format);
    this.querySelector('[data-freq-total]') && (this.querySelector('[data-freq-total]').innerHTML = addOnPrice);
  }

  selectFirstRadioInput = () => {
    var productCards = this.querySelectorAll('.rec-product-wrapper[data-product-id]');
    if (productCards) {
      productCards.forEach(pr => {
        var radioLength = pr.querySelectorAll('.rec_product-size input[type=radio]');
        if (radioLength != null && radioLength.length > 0) {
          radioLength[0].checked = true;
        }
      })
    }
  }

  init = () => {
    this.selectFirstRadioInput();
  }

}
customElements.define('frequent-bought', frequentBought);